export const slugify = text => {
  return text.toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-') 
}

export const formatDate = (value) => {
  return new Date(value).toLocaleDateString('en-AU')
}

export const removeTags = (value) => {
  return value.replace(/(<([^>]+)>)/gi, '')
}

export const trimMetaDescription = (value) => {
  return value.substring(0, 160)
}

export const isBrowser = typeof window !== 'undefined'